






































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import PageTemplateCard from '@/web/components/pages/PageTemplateCard.vue';
import AddPageModal from '@/web/components/pages/AddPageModal.vue';

export default Vue.extend({
  name: 'AddPage',
  components: {
    PageTemplateCard,
  },
  data() {
    return {
      searchWord: '',
      isLoading: false,
      pageTemplates: [],
      pageTemplateCategories: undefined,
      filteredCategoryId: undefined,
    };
  },
  computed: {
    ...mapGetters({
      page: 'page/page',
      formSaveFun: 'globals/formSaveFun',
    }),
    filterPageTemplates() {
      return this.pageTemplates
        .filter(
          ({ id }) => !this.filteredCategoryId || id === this.filteredCategoryId
        )
        .filter(({ name }) =>
          name.toLowerCase().includes(this.searchWord.toLowerCase() ?? '')
        );
    },
  },
  methods: {
    createPage(pageTemplate) {
      this.$modal.show(
        AddPageModal,
        {
          pageTemplate: pageTemplate,
        },
        {},
        {
          onCreatePage: id => this.onCreatePage(id),
        }
      );
    },
    onCreatePage(id) {
      this.$router.replace({
        name: 'page-builder',
        params: { id },
      });
    },
    selectFilteredCategoryId(id) {
      if (this.filteredCategoryId === id) {
        this.filteredCategoryId = undefined;
      } else {
        this.filteredCategoryId = id;
      }
    },
  },
  async created() {
    this.pageTemplates = await this.$store.dispatch('page/getPageTemplates');
    this.pageTemplateCategories = await this.$store.dispatch(
      'page/getPageTemplateCategories'
    );
  },
});
